import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ca80b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "multi-select-filter-years",
  ref: "dropDownSelectYears"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overselect" }, null, -1))
const _hoisted_3 = { class: "c-form-input" }
const _hoisted_4 = { value: "" }
const _hoisted_5 = {
  key: 0,
  class: "multiselect"
}
const _hoisted_6 = { class: "checkbox-button" }
const _hoisted_7 = ["id", "onUpdate:modelValue", "onClick"]
const _hoisted_8 = {
  class: "checkbox-elmt",
  style: {"border":"none"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
], -1))
const _hoisted_10 = { class: "checkbox-text" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown", _ctx.showMultiSelect ? 'expended' : '']),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggleMultiSelect && _ctx.toggleMultiSelect(...args)))
    }, [
      _hoisted_2,
      _createElementVNode("select", _hoisted_3, [
        _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.selectedYearsText), 1)
      ])
    ], 2),
    (_ctx.showMultiSelect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearsList, (year, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("label", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: index,
                    "onUpdate:modelValue": $event => ((year.selected) = $event),
                    onClick: $event => (_ctx.onSelectedYearsChanged(index))
                  }, null, 8, _hoisted_7), [
                    [_vModelCheckbox, year.selected]
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(year.name), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}